import React, {useEffect, useMemo} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { FormattedMessage } from 'react-intl'

const AddressItem = props => {
    useStyles(classes)
    const { address, addressEdit, addressDelete, addressDefault} = props || {}

    const stateCountry = useMemo(() => {
        let stateStr = address?.state ? (address?.state?.label ? address.state.label : address.state?.value) : '';
        if(stateStr)
            return stateStr + ', ' + address?.country?.label
        return address?.country?.label
    },[address])

    return address ?<div className={classes.AddressItem}>
        <div className={classes.AddressTitle}>
            {`${address?.name || ''} ${address?.phoneNumber ? '('+ (address?.phoneArea || '')+address?.phoneNumber +')': ''}`}
        </div>
        <div className={classes.AddressContent}>
            <div className={classes.Street}>
                {`${address?.streetAddress1 || ''} ${address?.unit ? ', ' + address?.unit: ''}`}
            </div>
            <div className={classes.Country}>
                {`${address?.zipCode || ''}${address?.city ? ', ' + address?.city: ''}${stateCountry ? ', ' + stateCountry: ''}`}
            </div>
        </div>
        <div className={classes.AddressButtons}>
            <div className={classes.stCell}>
                <span className={`${classes.Check} ${address?.isDefaultAddress ? classes.Active: ''}`} onClick={() => addressDefault(address?.id)}></span>
                <span className={classes.Default}><FormattedMessage id="default" defaultMessage={'Default'}/></span>
            </div>
            <div className={classes.stCell} style={{textAlign:'right'}}>
                <Iconfont className={classes.Edit} onClick={() => addressEdit(address)}>&#xe641;</Iconfont>
                <Iconfont className={classes.Delete} onClick={() => addressDelete(address)}>&#xe777;</Iconfont>
            </div>

            {
                address?.isDefaultAddress &&
                <div className={classes.borderActive}></div>
            }

        </div>
    </div>: <React.Fragment></React.Fragment>
}

const AddressList = props => {
    useStyles(classes)

    const { addressList, } = props || {}

    return <div className={classes.AddressList}>
        {
            addressList?.map((item, index) => {
                return <AddressItem {...props} key={index} address={item} />
            })
        }
    </div>
}


export default(AddressList)